var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSprout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.5391,
    y: 20.5127,
    width: 14.359,
    height: 3.07692,
    rx: 1.53846,
    transform: "rotate(90 21.5391 20.5127)",
    fill: "#AFF1D1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.20508,
    y: 31.7949,
    width: 23.5897,
    height: 3.07692,
    rx: 1.53846,
    fill: "#A37A50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81468 16.0877C7.67864 14.963 8.4801 13.941 9.6048 13.8049L10.623 13.6818C15.1218 13.1376 19.2099 16.3435 19.7541 20.8422L19.8772 21.8605C20.0133 22.9852 19.2118 24.0072 18.0871 24.1432L17.0689 24.2664C12.5701 24.8106 8.482 21.6047 7.93784 17.1059L7.81468 16.0877Z",
    fill: "#37DC8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1853 16.0877C32.3214 14.963 31.5199 13.941 30.3952 13.8049L29.377 13.6818C24.8782 13.1376 20.7901 16.3435 20.2459 20.8422L20.1228 21.8605C19.9867 22.9852 20.7882 24.0072 21.9129 24.1432L22.9311 24.2664C27.4299 24.8106 31.518 21.6047 32.0622 17.1059L32.1853 16.0877Z",
    fill: "#37DC8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9015 6.18708C16.3093 4.77553 18.5918 4.77553 19.9995 6.18708C21.4073 4.77553 23.6898 4.77553 25.0976 6.18708C26.5053 7.59864 26.5053 9.88722 25.0976 11.2988L21.452 14.9542C20.6504 15.7578 19.3486 15.7578 18.5471 14.9542L14.9015 11.2988C13.4938 9.88722 13.4938 7.59864 14.9015 6.18708Z",
    fill: "#FFAFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSprout);
export default __webpack_public_path__ + "static/media/ic_sprout.d4bd30a2f18c7ecb8bc8b5b4aaad97e3.svg";
export { ForwardRef as ReactComponent };